import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggler', 'toggledElement']

  connect() {
    this.applyElementVisibility = this.applyElementVisibility.bind(this)
    this.togglerTarget.addEventListener('change', this.applyElementVisibility)

    this.applyElementVisibility()
  }

  applyElementVisibility() {
    this.toggledElementTarget.classList.toggle('tw:hidden', !this.togglerTarget.checked)
  }
}
